import { defineMessages } from 'react-intl';

export default defineMessages({
  collateralComposition: 'Collateral composition',
});
